export enum ScoreCategory {
    LOW = 0,
    NORMAL = 1,
    HIGH = 2,
    NOT_PROCESSED = 3,
}
